const resetCheckbox = (checkbox) => { checkbox.checked = false; };

export default resetCheckbox;
